import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { forEach } from 'lodash';
import { Helper } from '../../../shared/helpers/helper';
import { TreatmentService } from '../../../shared/services/treatment.service';
import { NbDialogService } from '@nebular/theme';
import { ModalConfirmComponent } from '../../../shared/components/modals/confirm/modal-confirm.component';
import { ToasterService } from '../../../shared/services/toaster.service';
import { UserRolesService } from '../../../shared/services/user-roles.service';
import { UserAuthService } from '../../../shared/services/user-auth.service';
import { environment } from '../../../../environments/environment';
import { DATA_FILES_EXT } from '../../../shared/helpers/app.constants';
import { DataFilesService } from '../../../shared/services/data-files.service';

@Component({
  selector: 'app-data-files',
  templateUrl: './data-files.component.html',
  styleUrls: ['./data-files.component.scss']
})
export class DataFilesComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  // Permission
  isDataEngineer: boolean = false;

  selectedFile = null;
  submitted: boolean = false;
  loading: boolean = false;
  wellId: number;
  wellName: string = '';
  treatmentId: number;
  treatmentName: string = '';
  paramWells: any = {
    wellUid: null,
    serviceCompanyName: null,
    operatorName: null
  };
  dataSource: any[] = [];
  // Paging
  pagingState = {
    page: 1,
    pageSize: 24,
    collectionSize: 10
  };

  dataFileExts: string = DATA_FILES_EXT;

  get dataTable(): any[] {
    const result = this.dataSource
      .slice(
        (this.pagingState.page - 1) * this.pagingState.pageSize,
        (this.pagingState.page - 1) * this.pagingState.pageSize + this.pagingState.pageSize
      );

    return result;
  }

  constructor(
    private route: ActivatedRoute,
    private treatmentService: TreatmentService,
    private dataFilesService: DataFilesService,
    private dialogService: NbDialogService,
    private location: Location,
    private toasterService: ToasterService,
    private userAuthService: UserAuthService,
    private userRolesService: UserRolesService
  ) {
    const userInfo = this.userAuthService.getUserInfo();
    const userRole = this.userRolesService.toUserRole(userInfo);
    if (this.userRolesService.isDataEngineer(userRole) || this.userRolesService.isAnalyst(userRole)) {
      this.isDataEngineer = true;
    }
  }

  ngOnInit() {
    this.route.queryParams.subscribe((param: any) => {
      if (param) {
        this.wellId = (param && param.wellId) ? param.wellId : null;
        this.wellName = (param && param.wellName) ? param.wellName : null;
        this.treatmentId = (param && param.treatmentId) ? param.treatmentId : null;
        this.treatmentName = (param && param.treatmentName) ? param.treatmentName : null;
        this.paramWells.wellUid = (param && param.wellUid) ? param.wellUid : null;
        this.paramWells.serviceCompanyName = (param && param.serviceCompanyName) ? param.serviceCompanyName : null;
        this.paramWells.operatorName = (param && param.operatorName) ? param.operatorName : null;
        this.getDataFiles(this.wellId, this.treatmentId);
      }
    });
  }

  ngOnDestroy() {
    Helper.unsubscribe(this.subscriptions);
  }

  getDataFiles(wellId: number, treatmentId: number) {
    this.loading = true;
    this.subscriptions.push(
      this.dataFilesService.getDataFiles(wellId, treatmentId).subscribe(
        (res) => {
          if (res && res.result) {
            this.dataSource = res.result;
            this.pagingState.collectionSize = res.result.length;
          }
          this.loading = false;
      }, (error) => {
          this.loading = false;
        })
    );
  }

  onDeleteConfirm(fileName): void {
    this.dialogService.open(ModalConfirmComponent, {
      context: {
        config: {
          title: 'Delete',
          message: `Are you sure you want to delete <br> <b class="h6">${fileName}</b>?`,
          className: 'pop-delete common-page',
          btnTxtConfirm: 'Yes',
          btnTxtCancel: 'No',
        }
      }
    }).onClose.subscribe(res => {
      if (res && res.confirm) {
        this.onDelete(fileName);
      }
    });
  }

  onDelete(fileName) {
    this.dataFilesService.deleteDataFiles(fileName, this.wellId, this.treatmentId).subscribe(() => {
      this.getDataFiles(this.wellId, this.treatmentId);
    });
  }

  backClicked() {
    this.location.back();
  }

  uploadFileData(event: Event, element) {
    event.stopPropagation();
    event.preventDefault();
    if (element) {
      element.click();
    }
  }

  resetFileSelected(element) {
    this.selectedFile = null;
    if (element) {
      element.value = null;
    }
  }

  fileSelectChange(event, element) {
    if (event && event.target.files) {
      const curFileNames = this.dataTable.map(item => item.dataFile);
      this.selectedFile = event.target.files[0];
      if ((this.wellId || this.treatmentId) && this.selectedFile) {
        if (!curFileNames.includes(this.selectedFile.name)) {
          this.submitted = true;
          // Upload File
          this.dataFilesService.uploadDataFiles(this.selectedFile, this.wellId, this.treatmentId).subscribe(response => {
            // check data status is available to view
            this.toasterService.showSuccess('Uploaded Successfully');
            this.resetFileSelected(element);
            this.getDataFiles(this.wellId, this.treatmentId);
            this.submitted = false;
          }, (err) => {
            this.resetFileSelected(element);
            this.submitted = false;
          });
        } else {
          this.toasterService.showError('This file name already exists');
        }
      }
    }
  }

  onDownloadFile(fileName: string) {
    if (this.treatmentId) {
      return `${environment.api_url}/wells/${this.wellId}/treatments/${this.treatmentId}/dataFiles/${fileName}`;
    }
    return `${environment.api_url}/wells/${this.wellId}/dataFiles/${fileName}`;
  }

}
